<template>
  <el-dialog title="账单明细" :visible.sync="zhangdanDetailVisible" :close-on-click-modal="false" width="90%" center :before-close="guanbi">
    <div class="detailsTitle">
      <h4>收费明细</h4>
    </div>
    <el-table height="200px" size="mini" border center bordersize="mini" ref="tabref1" :data="tableDataMX" style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row>
      <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="feeItem" label="费目" align="center"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="allNumber" label="总件数" align="center"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量(吨)" align="center"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="standard" label="标准" align="center"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="totalFee" label="合计(元)" align="center"></el-table-column>
    </el-table>
    <div>
      <div style="position:relative;margin:30px 0;">
        <span>结算费用：<span style="color:red">{{totalFee}}</span> 元</span>
      </div>
      <div style="position:relative">
        付款方式：
        <div style="display:inline-block;margin:0 10px;" :class="this.JSway == 3?'active1':'active'">
          <img src="@/assets/images/money02.png" alt="" style="height:25px;position:absolute;top:3px">
          <span style="margin-left:35px">其他</span>
        </div>
      </div>
    </div>
    <div slot="footer">
      <el-button  size="mini" @click="guanbi">关闭</el-button>
      <el-button type="primary" size="mini" @click="jaiofeiFN" v-if="flag==1&&fkFlag">缴费</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getInventoryFeeList } from '@/api/wms-stock'
import { getFeeDetailList, finishFee } from '@/api/soc-stock'
export default {
  name: 'billsDetail',
  data () {
    return {
      tableDataMX: [],
      JSway: 3,
      totalFee: ''
    }
  },
  props: {
    zhangdanDetailVisible: {
      type: Boolean,
      default: false
    },
    inventoryDivideId: {
      type: String,
      default: ''
    },
    feeMasterId: {
      type: String,
      default: ''
    },
    inventoryMasterId: {
      type: String,
      default: ''
    },
    flag: {// 1代表货主端过来
      type: Number,
      default: 0
    },
    fkFlag: {// 1代表货主端过来
      type: Boolean,
      default: true
    }
  },
  mounted () {
    this.getTable()
  },
  methods: {
    jaiofeiFN () {
      finishFee({
        inventoryMasterId: this.inventoryMasterId,
        feeMasterId: this.tableDataMX[0].feeMasterId,
        userName: localStorage.getItem('userName'),
        userCode: localStorage.getItem('userCode')
      }).then(res => {
        this.$message({
          message: '缴费成功',
          type: 'success'
        })
        this.$emit('jiaofei')
      }).catch(err => {
        this.$message({ message: err.message, type: 'error' })
      })
    },
    guanbi () {
      this.$emit('update:zhangdanDetailVisible', false)
    },
    getTable () {
      if (this.flag == 1) {
        getFeeDetailList({ inventoryMasterId: this.inventoryMasterId })
          .then(res => {
            this.tableDataMX = res.list
            this.totalFee = res.totalFee
          })
          .catch(err => {
            this.$message({ message: err.message, type: 'error' })
          })
      } else {
        getInventoryFeeList({ inventoryDivideId: this.inventoryDivideId, feeMasterId: this.feeMasterId, inventoryMasterId: this.inventoryMasterId })
          .then(res => {
            this.tableDataMX = res.list
            this.totalFee = res.totalFee
          })
          .catch(err => {
            this.$message({ message: err.message, type: 'error' })
          })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.active {
  border: 1px solid #e8e8e8;
  margin-bottom: 5px;
  position: relative;
  border-radius: 5px;
  padding-left: 5px;
}
.active1 {
  border: 1px solid #106eec;
  margin-bottom: 5px;
  position: relative;
  border-radius: 5px;
  padding: 5px;
}
</style>
